module.exports = __webpack_public_path__ + "static/assets/279e5c05c69bcd19f76b9ca86bfa7ec5.gif";